import Icon from '@components/atoms/icon/icon';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { SellingOffersProduct } from '@interfaces/models/negotiation/domain/SellingOffersProduct';
import ProductImage from '@components/atoms/vc-images/components/product-image';
import BuyerFeesModal from '@components/buyer-fees/buyer-fees-modale/buyer-fees-modale';
import Link from 'next/link';
import { ImagesService } from '@services/image-service';
import styles from './negotiation-product-card.module.scss';

interface ProductItemListCardProps {
  product: SellingOffersProduct;
}

export const NegotiationProductCard: React.FC<ProductItemListCardProps> = ({ product }) => {
  const { t } = useTranslation('common');
  const { t: tA11y } = useTranslation('a11y');
  const picturePath = ImagesService.improveSEOProductPathImg(product.picturePath, product.path);

  return (
    <div className={clsx(styles.productCard)}>
      <Link
        href={product.path}
        className={styles.productCard__imgContainer}
      >
        <ProductImage
          sizesOverwrite={[128]}
          src={picturePath}
          width={80}
          height={80}
          quality={70}
          alt={product.subHeadline}
          type="thumbnail"
          fetchPriority="low"
        />
      </Link>
      <div className={styles.productCard__info}>
        <div
          className={styles.productCard__info__headline}
          data-cy="selling_offers_product_title"
        >
          <div className={styles.productCard__info__brand}>{product.headline}</div>
          <div className={styles.productCard__info__productName}>{product.subHeadline}</div>
        </div>
        <div
          className={styles.productCard__info__price}
          data-cy="selling_offers_product_price"
        >
          {product.price.formatted}
          <span className={styles.productCard__info__youEarn}>
            {t('MMAO.SELLER.YOU_EARN')}: {product.sellerEarnings.formatted}
          </span>
        </div>
        <div
          className={styles.productCard__info__buyingFeesDisclaimer}
          data-cy="selling_offers_product_disclaimer"
        >
          <div>{t('BUYERFEE.DISCLAIMER.EXCLUDED.SELLER')}</div>
          <div className={styles.productCard__info__buyingFeesDisclaimer__iconContainer}>
            <BuyerFeesModal
              isSeller={true}
              trackingContext="selling-offers"
              productId={String(product.id)}
              offerDetails={product.offerDetails}
            >
              <div className={styles.productCard__info__buyingFeesDisclaimer__icon}>
                <Icon
                  name="infobox-default"
                  data-cy="selling-offers-negotiation-product-card-info-icon"
                  ariaLabel={tA11y('A11Y.ICON.INFO_SELLER_FEE')}
                />
              </div>
            </BuyerFeesModal>
          </div>
        </div>
      </div>
    </div>
  );
};
